import Swal from "sweetalert";

const isLocalhost = Boolean(
  window.location.hostname === "localhost" ||
    // [::1] is the IPv6 localhost address.
    window.location.hostname === "[::1]" ||
    // 127.0.0.0/8 are considered localhost for IPv4.
    window.location.hostname.match(
      /^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/
    )
);

export function register(config) {
  //   if (process.env.NODE_ENV === "production" && "serviceWorker" in navigator) {
  if ("serviceWorker" in navigator) {
    // The URL constructor is available in all browsers that support SW.
    // const publicUrl = new URL(process.env.PUBLIC_URL, window.location.href);
    const publicUrl = new URL(window.location.origin, window.location.href);

    if (publicUrl.origin !== window.location.origin) {
      // Our service worker won't work if PUBLIC_URL is on a different origin
      // from what our page is served on. This might happen if a CDN is used to
      // serve assets; see https://github.com/facebook/create-react-app/issues/2374
      return;
    }

    window.addEventListener("load", () => {
      //   const swUrl = `${process.env.PUBLIC_URL}/service-worker.js`;
      const swUrl = `/service-worker.js`;

      if (isLocalhost) {
        // This is running on localhost. Let's check if a service worker still exists or not.
        checkValidServiceWorker(swUrl, config);

        // Add some additional logging to localhost, pointing developers to the
        // service worker/PWA documentation.
        navigator.serviceWorker.ready.then(() => {
          console.log(
            "This web app is being served cache-first by a service " +
              "worker. To learn more, visit https://cra.link/PWA"
          );
        });
      } else {
        // Is not localhost. Just register service worker
        registerValidSW(swUrl, config);
      }
    });
  }
}

function registerValidSW(swUrl, config) {
  navigator.serviceWorker
    .register(swUrl)
    .then((registration) => {
      // Check for updates every minute
      setInterval(() => {
        registration.update();
      }, 60000);

      registration.onupdatefound = () => {
        const installingWorker = registration.installing;
        if (installingWorker == null) {
          return;
        }
        installingWorker.onstatechange = () => {
          if (installingWorker.state === "installed") {
            if (navigator.serviceWorker.controller && window.location.pathname !== "/login") {
              console.log("Novo conteudo disponivel");

              //   //   Show a confirmation dialog
              //   const userConfirmed = window.confirm(
              //     "Novo update no sistema disponivel, favor fazer login novamente para atualizar, teste."
              //   );

              //   if (userConfirmed && window.location.pathname !== "/login") {
              //     // window.location.reload();
              //     window.location.href = "/login";
              //   }

              window.alert(
                "Novo update no sistema disponivel, favor fazer login novamente para atualizar."
              );

              //   Swal({
              //     title: "Atualização Disponível",
              //     text: "Novo update no sistema disponível. Favor fazer login novamente para atualizar.",
              //     icon: "info",
              //     button: "OK",
              //   });

              //   Swal({
              //     title: "Atualização Disponível",
              //     text: "Novo update no sistema disponível. Favor fazer login novamente para atualizar.",
              //     icon: "info",
              //     button: "OK",
              //   }).then((resp) => {
              //     if (resp) {
              //       window.location.href = "/login"; // Redirect to login
              //     }
              //   });

              // Execute callback
              if (config && config.onUpdate) {
                config.onUpdate(registration);
              }
            } else {
              console.log("Content is cached for offline use.");
            }
          }
        };
      };
    })
    .catch((error) => {
      console.error("Error during service worker registration:", error);
    });

  navigator.serviceWorker.addEventListener("controllerchange", () => {
    if (window.location.pathname !== "/login") {
      console.log(
        "Nova versão do sistema detectada. Favor fazer login novamente para atualizar."
      );
    }
  });
}

function checkValidServiceWorker(swUrl, config) {
  // Check if the service worker can be found. If it can't reload the page.
  fetch(swUrl, {
    headers: { "Service-Worker": "script" },
  })
    .then((response) => {
      // Ensure service worker exists, and that we really are getting a JS file.
      const contentType = response.headers.get("content-type");
      if (
        response.status === 404 ||
        (contentType != null && contentType.indexOf("javascript") === -1)
      ) {
        // No service worker found. Probably a different app. Reload the page.
        navigator.serviceWorker.ready.then((registration) => {
          registration.unregister().then(() => {
            window.location.reload();
          });
        });
      } else {
        // Service worker found. Proceed as normal.
        registerValidSW(swUrl, config);
      }
    })
    .catch(() => {
      console.log(
        "No internet connection found. App is running in offline mode."
      );
    });
}

export function unregister() {
  if ("serviceWorker" in navigator) {
    navigator.serviceWorker.ready
      .then((registration) => {
        registration.unregister();
      })
      .catch((error) => {
        console.error(error.message);
      });
  }
}
